/* tslint:disable */
/* eslint-disable */
/**
 * profile-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const HostAcceptedStatus = {
    Accepted: 'Accepted',
    NotAccepted: 'Not Accepted',
    ProvisionallyAccepted: 'Provisionally Accepted',
    ConditionallyAccepted: 'Conditionally Accepted'
} as const;

export type HostAcceptedStatus = typeof HostAcceptedStatus[keyof typeof HostAcceptedStatus];



